import PropTypes from 'prop-types';
import { Select, MenuItem, Chip } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useIsUserAdmin } from '../../../../../hooks/useUserHook';
import { isOrganizationAdmin } from '../../../../../utils/organizationUtils';
import {
    ORGANIZATION_USER_STATUS_ADMIN,
    ORGANIZATION_USER_STATUS_VIEWER,
    ORGANIZATION_USER_STATUS_USER,
} from './../../../../../config/constants';

const OrganizationUserStatusColumn = (props) => {
    const { organizationUser } = props,
        isUserAdmin = useIsUserAdmin(),
        organizationUserStatus = organizationUser.isAdmin ? 1 : 2,
        isStatusActive = isOrganizationAdmin(organizationUserStatus);

    const adminOptions = [
        { value: ORGANIZATION_USER_STATUS_ADMIN, label: 'Admin' },
        { value: ORGANIZATION_USER_STATUS_VIEWER, label: 'Viewer' },
        { value: ORGANIZATION_USER_STATUS_USER, label: 'User' },
    ];

    let renderStatus;
    if (isOrganizationAdmin(organizationUserStatus)) {
        renderStatus = (
            <Chip
                style={{
                    fontSize: '0.875rem',
                    fontWeight: '700',
                    backgroundColor: '#F2F2F2',
                }}
                label="Admin"
            />
        );
    } else if (isStatusActive) {
        renderStatus = (
            <Chip
                style={{
                    fontSize: '0.875rem',
                    fontWeight: '700',
                    backgroundColor: '#F2F2F2',
                }}
                label="Viewer"
            />
        );
    } else if (!isStatusActive) {
        renderStatus = (
            <Chip
                style={{
                    fontSize: '0.875rem',
                    fontWeight: '700',
                    backgroundColor: '#F2F2F2',
                }}
                label="User"
            />
        );
    } else {
        renderStatus = null;
    }

    const theme = createTheme({
        components: {
            MuiSelect: {
                styleOverrides: {
                    borderWidth: 0,
                    root: {
                        borderWidth: 0,
                        color: '#333333',
                        backgroundColor: '#FFFFFF',
                        boxShadow: 'none',
                        fontSize: 14,
                        fontWeight: 400,
                    },
                },
            },
        },
    });

    const renderSelectorganizationUserStatus = (
        <ThemeProvider theme={theme}>
            <Select
                labelId="Status"
                id="status"
                fullWidth
                variant="outlined"
                label=""
                onChange={() => {}}
                value={organizationUserStatus}
            >
                {adminOptions &&
                    adminOptions?.map((item, index) => {
                        return (
                            <MenuItem
                                key={'status-' + index}
                                selected={item.value === organizationUserStatus}
                                value={item.value}
                            >
                                {item.label}
                            </MenuItem>
                        );
                    })}
            </Select>
        </ThemeProvider>
    );

    return <div style={{ width: '100%' }}>{isUserAdmin ? renderSelectorganizationUserStatus : renderStatus}</div>;
};

OrganizationUserStatusColumn.propTypes = {
    organizationUser: PropTypes.object.isRequired,
};

export default OrganizationUserStatusColumn;
